<template>
  <div class="control-section">
    <pre>{{templateContent}}</pre>
  </div>
</template>
<script>
import Vue from 'vue';
import { TreeGridPlugin, Edit, Page, Toolbar, TreeGridComponent } from '@syncfusion/ej2-vue-treegrid';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DataManager, WebApiAdaptor } from "@syncfusion/ej2-data";

Vue.use(TreeGridPlugin, DropDownListPlugin);

export default {
  name: 'OneKeyDeployment',
  components: {
  },
  data() {
    return {
      templateContent: '',
      processName: 'ems_micrpoc',
      content: '',
      environmentId: ''
    };
  },
  methods: {
    getTemplateContent(checkData) {
      this.templateContent = checkData.deploymentTemplate;
      this.content = checkData.content;
      this.environmentId = checkData.id;
    },
    getData() {
      const content = JSON.parse(this.content);
      return {
        info: {
          processName: this.processName,
          ip: content.dpIp,
          port: content.dpPort,
          id: this.environmentId
        },
        vo: this.templateContent
      };
    }
  },
  mounted() {
  }
};
</script>
